// extracted by mini-css-extract-plugin
export default {"label":"InputField_label__A1RB8","input":"InputField_input__k2R5h","formInput":"InputField_formInput__WT6wR","unlabel":"InputField_unlabel__j+wSG"};